import React from 'react'
import { Chip, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import InputNumberItem from 'components/Input/InputNumber';
import { TextFieldInputNumber, numberFormatterLocale, parseFloatCheckValue } from '../Ticket/fnTickit';
import _ from "lodash";
import AccordionPanel from 'view/FrontEnd/Project/components/AccordionPanel';
import InputReactNumber from '../InputReactNumber';
import { formatNumber } from 'utilities/utilities';

const TableIncomeMuseum = (props) => {

    const { keyId, lstIncome, setlstIncome, arrQuater, arrMonth, isView, isVersion } = props;


    const handleChangeValue = (eValue, rowIndexMuseum, rowIncome) => {
        rowIncome.value = parseFloatCheckValue(eValue);
        let sumTotal = _.sumBy(lstIncome[rowIndexMuseum].lstIncome, function (o: any) { return parseFloatCheckValue(o.value); });
        lstIncome[rowIndexMuseum].nTotal = sumTotal;
        setlstIncome(value => [...value]);
    }

    return (
        <Grid container spacing={2}>
            {
                lstIncome.map((item, indexMuseum) => {
                    let keyCellMuseum = item.nMuseumId + "_" + indexMuseum;
                    return (
                        <Grid key={keyCellMuseum} item xs={12}>
                            <AccordionPanel header={item.sMuseumName} >
                                <Grid container spacing={2}>
                                    {/* <Divider textAlign="left"><Chip className='incomeplan-chip font-weight-500' label={item.sMuseumName} /></Divider> */}
                                    <Grid item xs={12}>
                                        <TableContainer id='table-pinned' component={Paper}>
                                            <Table sx={{ minWidth: 1400 }} >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className="sticky-cell .pad-6 head-color head-z400" component="th" padding='none' rowSpan={2} style={{ minWidth: '200px', width: '200px' }}>รวมปีปฏิทิน</TableCell>
                                                        {
                                                            arrQuater.map(quater => {
                                                                return (
                                                                    <TableCell key={quater} component="th" padding='none' colSpan={3} style={{ minWidth: '450px', width: '450px' }}>{quater}</TableCell>
                                                                )
                                                            })
                                                        }
                                                    </TableRow>
                                                    <TableRow>
                                                        {
                                                            arrMonth.map(month => {
                                                                return (
                                                                    <TableCell key={month} component="th" padding='none'>{month}</TableCell>
                                                                )
                                                            })
                                                        }
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell
                                                            padding='none'
                                                            className="sticky-cell .pad-6"
                                                            style={{ backgroundColor: "#ffffff" }}
                                                        >
                                                            <TextField
                                                                id={keyId + item.nMuseumId + "_total"}
                                                                name={keyId + item.nMuseumId + "_total"}
                                                                value={item.nTotal ? formatNumber(item.nTotal, 2) : ""}
                                                                variant={"outlined"}
                                                                type={"text"}
                                                                size={"small"}
                                                                fullWidth={true}
                                                                disabled
                                                                inputProps={{
                                                                    style: {
                                                                        textAlign: "right",
                                                                    }
                                                                }}
                                                            />
                                                        </TableCell>

                                                        {
                                                            item.lstIncome.map(keyRow => {
                                                                let keyCellInput = keyId + item.nMuseumId + "_" + keyRow.name;
                                                                return (
                                                                    <TableCell
                                                                        key={keyCellInput}
                                                                        padding='none'
                                                                    >
                                                                        {
                                                                            isVersion ?
                                                                                <TextFieldInputNumber value={keyRow.value} digit={2} />
                                                                                :
                                                                                <InputReactNumber
                                                                                    id={keyCellInput}
                                                                                    name={keyCellInput}
                                                                                    defaultValue={keyRow.value}
                                                                                    required={false}
                                                                                    disabled={isView}
                                                                                    IsCanMinus={false}
                                                                                    IsShowMessageError={false}
                                                                                    onChange={(eValue) => handleChangeValue(eValue, indexMuseum, keyRow)}
                                                                                />
                                                                        }
                                                                    </TableCell>
                                                                )
                                                            })
                                                        }
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </AccordionPanel>
                        </Grid>

                    )
                })
            }
        </Grid>
    )
}

export default TableIncomeMuseum